import React from 'react'

import generateContext from '../../hooks/GenerateContext'
import EqxContinuumFooter, {EqxContinuumFooterButton, EqxContinuumFooterMenuItem} from './EqxContinuumFooter'
import EqxContinuumHeader, {
    EqxContinuumHeaderTopRightButton,
    EqxContinuumHeaderTopRightMenu,
    EqxContinuumHeaderTopRightMenuItem,
    EqxContinuumNavPageActionItem,
    EqxContinuumSidebarItem,
    EqxContinuumSidebarSubItem,
} from './EqxContinuumHeader'

import './EqxContinuumLayout.css'

const [EqxContinuumLayoutContextProvider, useEqxContinuumLayoutContext] = generateContext(
    React.createContext<{} | null>(null)
)

interface EqxContinuumLayoutProps {
    children: React.ReactNode
    pageActions?: React.ReactNode
    pageTitle?: string | React.ReactNode
    containerType?: string
    header?: React.ReactNode
    footer?: React.ReactNode
    topRightMenu?: React.ReactNode
    footerContent?: React.ReactNode
    append?: React.ReactNode
    logo: React.ReactNode
    sidebar: React.ReactNode
    dark?: boolean
}
function EqxContinuumLayout(props: EqxContinuumLayoutProps) {
    const [showSidebar, setShowSidebar] = React.useState(false)

    const pageTitle = props.pageTitle ?? 'Home'
    const containerType = props.containerType ?? 'md'
    const pageActions = props.pageActions ?? <></>
    const topRightMenu = props.topRightMenu ?? <></>
    const footerContent = props.footerContent ?? <></>
    const logo = props.logo
    const sidebar = props.sidebar

    const layoutContext = {
        showSidebar,
        setShowSidebar,
    }

    return (
        <EqxContinuumLayoutContextProvider value={layoutContext}>
            <div className="App">
                {props.header ?? (
                    <EqxContinuumHeader
                        pageTitle={pageTitle}
                        pageActions={pageActions}
                        topRightMenu={topRightMenu}
                        logo={logo}
                        sidebar={sidebar}
                    />
                )}
                <main className={'container-' + (containerType ? containerType : 'md') + ' text-start'}>
                    <div id="sidebar-spacer">{props.children}</div>
                </main>
                {props.footer ?? <EqxContinuumFooter>{footerContent}</EqxContinuumFooter>}
                {props.append}
            </div>
        </EqxContinuumLayoutContextProvider>
    )
}

export {
    EqxContinuumLayout as default,
    EqxContinuumFooter,
    EqxContinuumFooterButton,
    EqxContinuumFooterMenuItem,
    EqxContinuumHeaderTopRightButton,
    EqxContinuumHeaderTopRightMenu,
    EqxContinuumHeaderTopRightMenuItem,
    EqxContinuumNavPageActionItem,
    EqxContinuumSidebarItem,
    EqxContinuumSidebarSubItem,
    useEqxContinuumLayoutContext,
}
